import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarUnderlineIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        viewBox="0 0 32 32"
        className="Icon toolbar-underline"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#EBEDEE" rx={4} />
            <path
                fill="#48505E"
                fillRule="nonzero"
                d="M16.012 21.18c-.93 0-1.745-.179-2.442-.537a3.974 3.974 0 0 1-1.619-1.48c-.383-.63-.574-1.35-.574-2.163V9.36h1.778v7.497c0 .523.116.989.348 1.396.233.408.562.728.989.962.427.234.934.351 1.52.351.589 0 1.095-.117 1.52-.35.426-.235.753-.556.984-.963a2.79 2.79 0 0 0 .345-1.396V9.359h1.778V17c0 .814-.192 1.534-.575 2.164a3.985 3.985 0 0 1-1.614 1.48c-.693.358-1.506.537-2.438.537zM11.88 24h8.26a.5.5 0 1 0 0-1h-8.26a.5.5 0 1 0 0 1z"
            />
        </g>
    </svg>
);
const Memo = memo(ToolbarUnderlineIcon);
export default Memo;
